import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { EmbedDevice } from 'tag/ts/tag/model/type/embed/EmbedDevice';
import { Comcast } from 'tag/ts/tag/player/stv/configs/platforms/Comcast';
import { Cox } from 'tag/ts/tag/player/stv/configs/platforms/Cox';
import { LGNetCastConfigs } from 'tag/ts/tag/player/stv/configs/platforms/LGNetCastConfigs';
import { LGWebOSConfigs } from 'tag/ts/tag/player/stv/configs/platforms/LGWebOSConfigs';
import { NETGEM } from 'tag/ts/tag/player/stv/configs/platforms/NETGEM';
import { PlayStation4 } from 'tag/ts/tag/player/stv/configs/platforms/PlayStation4';
import { PlayStation5 } from 'tag/ts/tag/player/stv/configs/platforms/PlayStation5';
import { SAGEM } from 'tag/ts/tag/player/stv/configs/platforms/SAGEM';
import { SamsungTizen } from 'tag/ts/tag/player/stv/configs/platforms/SamsungTizen';
import { SonyHTML5 } from 'tag/ts/tag/player/stv/configs/platforms/SonyHTML5';
import { TCL } from 'tag/ts/tag/player/stv/configs/platforms/TCL';
import { TIVO } from 'tag/ts/tag/player/stv/configs/platforms/TIVO';
import { UnknownDevice } from 'tag/ts/tag/player/stv/configs/platforms/UnknownDevice';
import { VIDAA } from 'tag/ts/tag/player/stv/configs/platforms/VIDAA';
import { VizioConfigs } from 'tag/ts/tag/player/stv/configs/platforms/VizioConfigs';
import { XboxOne } from 'tag/ts/tag/player/stv/configs/platforms/XboxOne';
const deviceConfigMap = {
    [EmbedDevice.LG_WEB_OS]: LGWebOSConfigs,
    [EmbedDevice.LG_NETCAST]: LGNetCastConfigs,
    [EmbedDevice.SAMSUNG_TIZEN]: SamsungTizen,
    [EmbedDevice.VIZIO_SMART_TV]: VizioConfigs,
    [EmbedDevice.SONY_HTML5]: SonyHTML5,
    [EmbedDevice.SAGEM]: SAGEM,
    [EmbedDevice.NETGEM]: NETGEM,
    [EmbedDevice.XBOX_ONE]: XboxOne,
    [EmbedDevice.VIDAA]: VIDAA,
    [EmbedDevice.PS5]: PlayStation5,
    [EmbedDevice.COMCAST]: Comcast,
    [EmbedDevice.COX]: Cox,
    [EmbedDevice.TCL]: TCL,
    [EmbedDevice.TIVO]: TIVO,
    [EmbedDevice.PS4]: PlayStation4,
    [EmbedDevice.UNKNOWN]: UnknownDevice
};
export class STVPlatformConfigs extends AbstractTagClass {
    #platformConfigs;
    constructor(argument) {
        super({
            ...argument,
            name: 'STVPlatformConfigs'
        });
        this.#platformConfigs = STVPlatformConfigs.setConfigs(this?.params, this?.tag);
    }
    static setConfigs(params, tag) {
        const device = params?.SYSTEM?.device ?? EmbedDevice.UNKNOWN;
        const configClass = deviceConfigMap[device] ?? UnknownDevice;
        return new configClass(params, tag).configs;
    }
    get resourceConfig() {
        return this.#platformConfigs?.resourceConfig;
    }
    get playerOptions() {
        return this.#platformConfigs?.playerOptions;
    }
}
